module.exports = __webpack_public_path__ + "img/interactive-resource.svg";